import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import UserMenu from './UserMenu';
import NavMenu from './NavMenu';
import Tools from './Tools';
import Sidebar from './Sidebar';
import Toast from './Toast';
import MoreMenu from './ui/moreMenu/MoreMenu';
import './css/Home.css';
import ModalWindow from './ModalWindow';
import Box from './Box';
import { now } from 'moment';
import Alert from './Alert';
import Popover from './ui/Popover';
import { ReactComponent as CallIcon } from '../components/icons/call.svg';
import AdvanceMonitor from './ui/AdvanceMonitor';
import { ReactComponent as IconCampaigns } from './icons/campaigns.svg';
import Chatroom from './Chatroom';

const Campaigns = (props) => {
    const [campaigns, setCampaigns] = useState([]); 
    //const [campaign, setCampaign]= useState({}); 
    const [connectedCampaigns, setConnectedCampaigns]= useState([]);
    const [companies, setCompanies]= useState([]);
    const [currentCampaign, setCurrentCampaign]= useState(null); 
    const [sessionData, setSessionData] = useState({}); 
    const [error, setError] = useState(false);
    const history = useHistory();
    const [toastRef, setToastRef] = useState(React.createRef()); 
    const [campaignsPagination, setCampaignsPagination] = useState(null);
    const [loading, setLoading] = useState({});
    const [data, setData] = useState({ scheduleDate: new Date() }); 
    const [asteriskQueues, setAsteriskQueues] = useState([]); 
    const [visibleModalChangeRatio, setVisibleModalChangeRatio] = useState(false);
    const [selectedCampaignToChangeRadio, setSelectedCampaignToChangeRadio] = useState(null);
    const [campaignId, setCampaignId] = useState(null);
    const [searching, setSearching] = useState(true);
    const [currentUserStatus, setCurrentUserStatus] = useState(null);
    const [userStatus, setUserStatus] = useState(null); 
    const [disconnectionExecuted, setDisconnectionExecuted] = useState(false); 


    //const chatBeep = require("./ui/chatBeep.mp3"); 
    const demoFunction = (str) => {
        console.log(str);
    };

    const hours = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20']
    const minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55']

    let menus = [
        {
            title: "Agendar ejecución",
            action: () => demoFunction("primera")
        },
        {
            title: "Ejecutar ahora",
            action: () => demoFunction("segunda")
        },
        {
            title: "Eliminar",
            action: () => demoFunction("tercera")
        }
    ];

    useEffect(() => {
        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login');
        } else {
            
            //campaigns
            getCampaigns();

            //get companies (for filters)
            getCompanies();

            //get selected campaigns from session
            if(sessionStorage.getItem("connectedCampaigns")){
                setConnectedCampaigns(JSON.parse(sessionStorage.getItem("connectedCampaigns")));
            }

        }
    }, []);

    // useEffect(() => {
    //     //AUTO SELECT PRESELECTED CAMPAIGN IN PREVIOUS SESSIONS (IF EXIST IN LIST)
    //     let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    //     campaigns.map((listValue, index) => {
    //         if (listValue._id === currentSessionData.lastCampaignId) {
    //             let preselectedCampaignFromDB = { 
    //                 'campaignId': listValue._id, 
    //                 'companyId': listValue.companyId, 
    //                 'companyCode': listValue.company_info.code, 
    //                 'campaignName': listValue.name, 
    //                 'itemCount': listValue.itemCount, 
    //                 'ammount': listValue.ammount, 
    //                 'companyName': listValue.company_info.name, 
    //                 'type': listValue.type, 
    //                 'asteriskQueue': listValue.asteriskQueueInfo?listValue.asteriskQueueInfo.name:null,
    //                 'assignmentId':listValue.assignmentId
    //             };
    //             setCampaign(preselectedCampaignFromDB);
    //             sessionStorage.setItem('selectedCampaign', JSON.stringify(preselectedCampaignFromDB));
    //         }
    //     });
    // }, [campaigns]);


    const getCampaigns = (pagination = null) => {
        setLoading(true);

        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        setSessionData(currentSessionData);

        let serviceParams = {};
        if (pagination) { serviceParams.pagination = pagination }
        if (data.companyFilter) { serviceParams.companyFilter = data.companyFilter }
        if (data.searchFilter) { serviceParams.searchFilter = data.searchFilter }

        //----------------------------------
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/campaigns`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: serviceParams
        };
        axios(options).then(response => {

            //console.log('🐞DEBUG ---->', response);

            if (pagination) {
                setCampaigns([...campaigns, ...response.data[0].data]);
            }
            else {
                setCampaigns(response.data[0].data);
            }

            setCampaignsPagination(response.data[0].metadata[0]);
            setLoading(false);
        })
        .catch(function (error) {
            if (error?.response?.data?.error === 'Unauthorized'){
                console.log('🐞DEBUG NO AUTORIZADO ZZZZZ');
                if (!disconnectionExecuted) {
                    Tools.forceLogout(history);
                    setDisconnectionExecuted(true);
                }
            }
            setError(error.message);
            setLoading(false);
        });
    }


    const getCompanies=()=>{
         //get companies
         let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
         const options = {
             url: `${process.env.REACT_APP_URI_API_CRM}/companies`,
             method: 'GET',
             headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json;charset=UTF-8',
                 'Authorization': currentSessionData.token
             },
             params: {}
         };
         axios(options).then(response => {
             setCompanies(response.data);
         })
         .catch ((error) => {
            if (error?.response?.data?.error === 'Unauthorized') {
                if (!disconnectionExecuted) {
                    Tools.forceLogout(history);
                    setDisconnectionExecuted(true);
                }
            }
            setError(error.message);
            setLoading(false);
        });
    }


    const getAsteriskQueues = (currentCampaign) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/asteriskQueues`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: { companyId: currentCampaign.companyId}
        };
        axios(options).then(response => {
            setAsteriskQueues(response.data)
        })
        .catch ((error) => {
            if (error?.response?.data?.error === 'Unauthorized') {
                if (!disconnectionExecuted) {
                    Tools.forceLogout(history);
                    setDisconnectionExecuted(true);
                }
            }
            setError(error.message);
            setLoading(false);
        });
    }

    const scheduleCurrentCampaign = (currentCampaign)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/campaign`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: data
        };
        axios(options).then(response => {
            console.log('🐞DEBUG response:', response);
            setCurrentCampaign(null);
            getCampaigns();
            toastRef.current.addToast('Se agendó la campaña exitósamente', 5000);
        })
        .catch((error) => {
            if (error?.response?.data?.error === 'Unauthorized') {
                if (!disconnectionExecuted) {
                    Tools.forceLogout(history);
                    setDisconnectionExecuted(true);
                }
            }
            setError(error.message);
            setLoading(false);
        });
    }


    const executeUserAMIAction = (action)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/userAMIAction`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: action
        };
        axios(options).then(response => {
            //console.log('🐞DEBUG executeUserAMIAction response:', response);
        })
        .catch((error) => {
            if (error?.response?.data?.error === 'Unauthorized') {
                if (!disconnectionExecuted) {
                    Tools.forceLogout(history);
                    setDisconnectionExecuted(true);
                }
            }
            setError(error.message);
            setLoading(false);
        });
    }

    const notifyUserConnectCampaign =(campaignId, queue, dialerQueue, extension)=>{

        let prom=new Promise(function(resolve, reject) {
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));       
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/notifyConnectCampaign`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: {
                    campaignId: campaignId,
                    queue:queue,
                    dialerQueue:dialerQueue,
                    extension:sessionData.extension,
                    type:'outbound'
                }
            };
            
            axios(options).then(response => {
                if (response.status === 200) {
                    console.log('ok');
                    resolve('OK');
                }
            }).catch(function (error) {
                if (error?.response?.data?.error === 'Unauthorized') {
                    console.log('🐞DEBUG NO AUTORIZADO');
                    if (!disconnectionExecuted) {
                        Tools.forceLogout(history);
                        setDisconnectionExecuted(true);
                    }
                }
                setError(error.message);
                setLoading(false);
            });
        })

        return prom;

    }

    const assignCampaign = (selectedCampaign) => {


        console.log('🐞DEBUG selectedCampaign:', selectedCampaign);

        // let campaign={
        //     'campaignId': selectedCampaign._id, 
        //     'companyId': selectedCampaign.companyId, 
        //     'companyCode': selectedCampaign.company_info.code, 
        //     'campaignName': selectedCampaign.name, 
        //     'itemCount': selectedCampaign.itemCount,
        //     'companyName': selectedCampaign.company_info.name,
        //     'type':selectedCampaign.type,
        //     'assignmentId':selectedCampaign.assignmentId
        // };

        //AHORA NUEVAMENTE CREAR UN ARREGLO DE OBJETOS CAMPAÑA EN LA SESION
        //QUE DEBE LLEVAR LA COLA (PARA QUE CUANDO CAMBIE DE ESTADO EL USUARIO SEPA
        //PONER EN PAUSA LA COLA CORRESPONIDNTE ) CODIGO ACA ABAJO

        // console.log('🐞DEBUG asteriskQueueInfo.context:', selectedCampaign.asteriskQueueInfo.context);

        const connectedCampaignsList = [...connectedCampaigns];
        if (!connectedCampaignsList.some(e => e._id === selectedCampaign._id)) {
            let cmpObj={_id:selectedCampaign._id, context:selectedCampaign.asteriskQueueInfo.context};
            connectedCampaignsList.push(cmpObj);
            setConnectedCampaigns(connectedCampaignsList);
            sessionStorage.setItem("connectedCampaigns", JSON.stringify(connectedCampaignsList));
        }



        // const connectedCampaignsList = [...connectedCampaigns];
        // if(!connectedCampaignsList.includes(selectedCampaign._id)){
        //     connectedCampaignsList.push(selectedCampaign._id);
        //     setConnectedCampaigns(connectedCampaignsList);

        //     //save selection on session
        //     sessionStorage.setItem("connectedCampaigns", JSON.stringify(connectedCampaignsList));
        // }

        //update session data on sessionStorage
        // let sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        // sessionData.lastCampaignId = selectedCampaign._id;
        // sessionStorage.setItem('sessionData', JSON.stringify(sessionData));

        //connect to queue
        if (selectedCampaign.type ==='PROGRESSIVE'){
            notifyUserConnectCampaign(selectedCampaign._id, selectedCampaign.asteriskQueueInfo.name, selectedCampaign.asteriskQueueInfo.dialerQueue).then(function(result) {
                executeUserAMIAction({ action:'QUEUEADD', queue:selectedCampaign.asteriskQueueInfo.name, type:'outbound', paused:currentUserStatus});
            });
        }

        
        //update selected campaign on dataBase
        let data = { 'campaignId': selectedCampaign._id };
        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/user`); 
        fetch(url, {
            method: 'PUT',
            contentType: 'application/json',
            headers: { 'Authorization': sessionData.token, Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(data) 
        })
        .then(res => res.json())
        .then(
            (result) => {
              //usuario actualizado
            },
            (error) => {
                setError(error);
            }
        );

        //change user estatus to ACTIVE
        //console.log('🐞DEBUG ESTADO ACTUAL:',userStatus);
        setUserStatus({ paused: false, code: 'ACTIVE', desc:'Disponible'});
    }


    const assignChatCampaign = (selectedCampaign) => {
        console.log('🐞DEBUG selectedCampaign:', selectedCampaign);
        const connectedCampaignsList = [...connectedCampaigns];
        if (!connectedCampaignsList.some(e => e._id === selectedCampaign._id)) {
            let cmpObj = { _id: selectedCampaign._id, context: selectedCampaign.asteriskQueueInfo.context };
            connectedCampaignsList.push(cmpObj);
            setConnectedCampaigns(connectedCampaignsList);
            sessionStorage.setItem("connectedCampaigns", JSON.stringify(connectedCampaignsList));
        }

        //update selected campaign on dataBase
        let data = { 'campaignId': selectedCampaign._id };
        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/user`);
        fetch(url, {
            method: 'PUT',
            contentType: 'application/json',
            headers: { 'Authorization': sessionData.token, Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
        .then(res => res.json())
        .then(
            (result) => {
                //usuario actualizado
            },
            (error) => {
                setError(error);
            }
        );

        //change user estatus to ACTIVE
        //console.log('🐞DEBUG ESTADO ACTUAL:',userStatus);
        setUserStatus({ paused: false, code: 'ACTIVE', desc: 'Disponible' });


        // //play sound when socket receive chatCall, 
        // //must be here to capture CLICK event
        // const socket = Tools.currentSocketConnection;
        // socket.on("chatCall", data => {
        //     let audioBeep = new Audio(chatBeep);
        //     audioBeep.play();
        // });
    }


    const isConnected=(selectedCampaign)=>{
        return connectedCampaigns.some(e => e._id === selectedCampaign._id)
    }

    const unassignCampaign = (selectedCampaign) => {
        const connectedCampaignsList = [...connectedCampaigns];
        // const index = connectedCampaignsList.indexOf(selectedCampaign._id);
        // if (index > -1) { 
        //     connectedCampaignsList.splice(index, 1); 
        //     setConnectedCampaigns(connectedCampaignsList);

        //     //save selection on session
        //     sessionStorage.setItem("connectedCampaigns", JSON.stringify(connectedCampaignsList));
        // }

        let foundIndex=connectedCampaignsList.findIndex((cmp)=> cmp._id === selectedCampaign._id);
        if(foundIndex!==-1){
            connectedCampaignsList.splice(foundIndex, 1); 
            setConnectedCampaigns(connectedCampaignsList);
            
            //save selection on session
            sessionStorage.setItem("connectedCampaigns", JSON.stringify(connectedCampaignsList));



            let connectedInboundQueues=JSON.parse(sessionStorage.getItem("connectedInboundQueues"))??[];
            if(connectedCampaignsList.length===0 && connectedInboundQueues.length===0){
                setUserStatus({ paused: false, code: 'LOGGED', desc:'En sistema'});
            }  


        }

        let data = { 'campaignId': 'null'};
        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/user`); 
        fetch(url, {
            method: 'PUT',
            contentType: 'application/json',
            headers: { 'Authorization': sessionData.token, Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(data) 
        })
        .then(res => res.json())
        .then(
            (result) => {
              //usuario actualizado
            },
            (error) => {
                setError(error);
            }
        );
    }

    const deleteCampaign = (selectedCampaig) => {
        if (window.confirm("¿Está seguro de eliminar la campaña seleccionada?")){
            let data = { 'campaignId': selectedCampaig._id };
            let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/campaign`);
            fetch(url, {
                method: 'DELETE',
                contentType: 'application/json',
                headers: { 'Authorization': sessionData.token, Accept: 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(data) 
            })
            .then(res => res.json())
            .then(
                (result) => {
                    //refresh list
                    getCampaigns();
                },
                (error) => {
                    console.log('Se produjo un errrooooor:', error);
                    setError(error);
                }
            )
        }
    }

    const refreshCampaignsAndNotify = (selectedCampaigntype) =>{
        switch (selectedCampaigntype) {
            case 'NEW':
                toastRef.current.addToast('Se creó nueva campaña exitósamente', 5000);
                getCampaigns();
                break;
            case 'REDUCTION':
                toastRef.current.addToast('Se creó nueva campaña (rebaja) exitósamente', 5000);
                break;
        } 
    }

    const executeNow=(campaign)=>{
        if(window.confirm("Está seguro de ejecutar ahora la campaña  " + campaign.name + '?')){
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/campaignExcecuteNow`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: {campaignId:campaign._id}
            };
            axios(options).then(response => {
                //console.log('🐞DEBUG response:', response);
                getCampaigns();
                toastRef.current.addToast('Se inició ejecucución de campaña',5000);
            })
            .catch((error) => {
                if (error?.response?.data?.error === 'Unauthorized') {
                    if (!disconnectionExecuted) {
                        Tools.forceLogout(history);
                        setDisconnectionExecuted(true);
                    }
                }
                setError(error.message);
                setLoading(false);
            });
        }
    }

    const executeVoiceRobotCampaign=(campaign)=>{
        if(window.confirm("Está seguro de ejecutar la campaña  " + campaign.name + '?')){
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/excecuteVoiceRobotCampaign`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: {campaignId:campaign._id}
            };
            axios(options).then(response => {
                //console.log('🐞DEBUG response:', response);
                getCampaigns();
                toastRef.current.addToast('Se inició ejecucución de campaña de robot',5000);
            })
            .catch((error) => {
                if (error?.response?.data?.error === 'Unauthorized') {
                    if (!disconnectionExecuted) {
                        Tools.forceLogout(history);
                        setDisconnectionExecuted(true);
                    }
                }
                setError(error.message);
                setLoading(false);
            });
        }
    }

    const changeRatioDialing=(campaign)=>{
        setVisibleModalChangeRatio(true);
        setSelectedCampaignToChangeRadio(campaign);
    }

    const applyChangeRatioDialing=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/campaignRatio`,
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: {
                    campaignId:selectedCampaignToChangeRadio._id,
                    ratioDialing:data.ratioDialing,
                    campaignDialerQueue:selectedCampaignToChangeRadio.asteriskQueueInfo.dialerQueue
                }
            };
            axios(options).then(response => {
                //console.log('🐞DEBUG response:', response);
                getCampaigns();
                setVisibleModalChangeRatio(false);
                toastRef.current.addToast('Se modificó el ratio de campaña',5000);
            })
            .catch((error) => {
                if (error?.response?.data?.error === 'Unauthorized') {
                    if (!disconnectionExecuted) {
                        Tools.forceLogout(history);
                        setDisconnectionExecuted(true);
                    }
                }
                setError(error.message);
                setLoading(false);
            });
    }

    const scheduleCampaign=(campaign)=>{
        setCurrentCampaign(campaign);
        getAsteriskQueues(campaign);
        setData({ ...data, ['campaignId']: campaign._id });
    }

    const handleCalendar = (dateValue) => {
        setData({ ...data, ['scheduleDate']: dateValue })
    }

    const handleInputChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const buildStyle = ()=>{
        return "70%";
    }

    const resetSearch=()=>{

        const clonedData = data;
        clonedData['companyFilter']=undefined;
        clonedData['searchFilter']=undefined;
        setData(clonedData);
        setSearching(!searching); 
       

        // setData({ ...data, ['companyFilter']:undefined });
        // setData({ ...data, ['searchFilter']:undefined });
        getCampaigns();
       
    }

    const FoundValue = (props) => {
        if (props.searchValue){
            var replacement = new RegExp(props.searchValue, "gi");
            let highlightedText = String(props.children).replace(replacement, '<b>$&</b>');
            return <span dangerouslySetInnerHTML={{__html: highlightedText}}></span>
        } else {
            return <span>{props.children}</span>
        }
    }

    const fixedHeaderPosition={top:"152px"};

    return (
        <div className="mainWrapper">
            <Toast ref={toastRef}></Toast>
            <Sidebar key={props.inboundConnectedQueues} softphoneConnectionStatus={props.softphoneConnectionStatus}/>

            {currentCampaign?(
                <ModalWindow closeMethod={()=>{setCurrentCampaign(null)}}>
                    <h2 className='title'>Agendar campaña</h2>
                    <span className="upper subtitle">Seleccione los datos para el agendamiento para la<br/>campaña seleccionada</span>

                    <div className="flexRow">
                        <div className="flexCol">
                            <Box className="x3" type="readOnly" label="campaña" value={currentCampaign.name} />
                            <Box type="calendar" name='scheduleDate' label="Agendamiento" selectedDate={data.scheduleDate}  onChange={handleCalendar} required></Box>
                        </div>
                    </div>

                    <div className="flexRow">
                        
                        <div className="flexCol">
                            <div className="inputWrapper twoSelects">
                                <label className="required">Hora</label>
                                <div className="wrapper">
                                    <select name="hour" defaultValue="" onChange={handleInputChange}>
                                        <option value="" disabled hidden>--</option>
                                        {hours.map((option, index) =>
                                            <option key={index} value={option}>{option}</option>
                                        )}
                                    </select>
                                    <span>:</span>
                                    <select name="minute" defaultValue="" onChange={handleInputChange}>
                                        <option value="" disabled hidden>--</option>
                                        {minutes.map((option, index) =>
                                            <option key={index} value={option}>{option}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                        
                            <Box type="select" name="asteriskQueue" label="Cola Asterisk" className="x3" placeholder="Seleccione ..." options={asteriskQueues} onChange={handleInputChange} required></Box>
                            <button className="default collapsed" onClick={() => scheduleCurrentCampaign(currentCampaign)}>Agendar</button>
                        </div>
                    </div>

                    {/* <p>{JSON.stringify(data)}</p> */}
                    
                    

                </ModalWindow>):null
            }

            {visibleModalChangeRatio?(
                <ModalWindow closeMethod={()=>{setVisibleModalChangeRatio(false)}}>
                <h2 className='title'>Modificar ratio de discado</h2>
                <span className="upper subtitle">Seleccione el ratio de discado para la<br/>campaña seleccionada</span>
                <div className="flexRow">
                    <div className="flexCol">
                        <Box type="select" name="ratioDialing" label="ratio" className="" placeholder="Seleccione ..." options={[{ratio:1, desc:'1'},{ratio:1.5, desc:'1.5'},{ratio:2, desc:'2'},{ratio:2.5, desc:'2.5'},{ratio:3, desc:'3'}]} onChange={handleInputChange} required></Box>
                        <button className="default collapsed" onClick={() => applyChangeRatioDialing()}>Modificar</button>
                    </div>
                </div>
                </ModalWindow>
            ):null}

            <div className="main">
            <div className="headerWrapper">
                <div className="titleWrapper">
                    <h1 className={loading?'loading':''}><IconCampaigns/>Campañas</h1>
                    <span className="upper">Seleccione la campaña con la que desea conectarse.</span>
                </div>
                <div className="flexWrapper"> 
                    <UserMenu profile={sessionData.profile_desc} setInboundConnectedQueues={props.setInboundConnectedQueues} setCurrentUserStatus={setCurrentUserStatus} externalUserStatus={userStatus}/>
                </div>
            </div>

            
            {connectedCampaigns.length>0?(
                <Alert className="waiting mgb20">
                    <p>Conectado a campaña progresiva, en espera de llamados. &nbsp; </p>
                </Alert>
            ):null}

            <div key={searching} className="searchWrapper">
                <input type="search" name="searchFilter" placeholder="Ingrese un patrón de búsqueda..." size="40" onChange={handleInputChange}/>
                <select className='simple' name="companyFilter" defaultValue="" onChange={handleInputChange} required>
                    <option value="" disabled hidden>Empresa ...</option>
                    {companies.map(option =>
                        <option key={option._id} value={option._id}>{option.name}</option>
                    )}
                </select>
                <button className='default secondary' onClick={() => getCampaigns()}>Buscar</button>
                {data.companyFilter || data.searchFilter?(
                    <button className='default outline ml5' onClick={() => resetSearch()}>Limpiar</button>
                ):null}
            </div>

            <div className="tableWrapper">
                <table className="fullWidth">
                    <thead>
                        <tr>
                            <th style={fixedHeaderPosition}></th>
                            <th style={fixedHeaderPosition}>Cliente</th>
                            <th style={fixedHeaderPosition}>Nombre campaña</th>
                            <th style={fixedHeaderPosition}>Tipo</th>
                            {/* <th style={fixedHeaderPosition}>Estado</th> */}
                            <th className='center' style={fixedHeaderPosition}>Creación</th>
                            <th className='right' style={fixedHeaderPosition}>Regs.</th>
                            <th className='center' style={fixedHeaderPosition}>Avance</th>
                            <th style={fixedHeaderPosition}><button tooltip="Refrescar campañas" className='icon' onClick={()=>getCampaigns()}><i className="mask refresh"></i></button></th>
                        </tr>
                    </thead>
                    <tbody>
                        {campaigns.map((listValue, index) => {
                            return (
                                <tr key={index} className={`${isConnected(listValue)?'selected':''} ${(!listValue.active)?'inactive':''}`}>
                                    <td>
                                        {listValue.type==='ASSISTED'?(<i className="assisted mask"></i>):<i className="progressive mask"></i>}
                                    </td>
                                    <td>
                                        <span className='companyColor' style={{borderColor:listValue.company_info.color}}>{listValue.company_info.name}</span>
                                    </td>
                                    <td className='rel'>
                                        <a onClick={() => (listValue._id === campaignId)?setCampaignId(null):setCampaignId(listValue._id)}><i className='info'/></a> 
                                        {/* {listValue.name} */}
                                        <FoundValue searchValue={data.searchFilter}>{listValue.name}</FoundValue>
                                        <Popover show={listValue._id === campaignId} position="right">
                                            <dl>
                                                <dt>Id Campaña</dt>
                                                <dd>{listValue._id}</dd>
                                                <dt>Id Asignación</dt>
                                                <dd>{listValue.assignmentId}</dd>
                                                <dt>Registros</dt>
                                                <dd>{Tools.fmtClNumber(listValue.itemCount)}</dd>
                                            </dl>
                                        </Popover>
                                    </td>
                                    <td>{listValue.type}</td>
                                    {/* <td>{listValue.status_info.desc}</td> */}
                                    <td className='center'>{Tools.fdtCL(listValue.date)}</td>
                                    <td className='right'>{Tools.fmtClNumber(listValue.itemCount)}</td>
                                    <td>
                                        {isConnected(listValue)?(
                                            <AdvanceMonitor campaignId={listValue._id}/>
                                        ):(
                                            <div className="advanceMonitor"><div className="progressbar"><div className="ind grayscale" style={{width: listValue.progress + "%"}}></div></div><div className="percentage">{listValue.progress}%</div></div>
                                        )}
                                    </td>

                                    <td className='sticky lastSticked center'>  
                                        {listValue.active?(
                                        <MoreMenu menuList={
                                            [
                                                {
                                                    title: "Conectarse",
                                                    action: () => { assignCampaign(listValue);},
                                                    visible:(listValue.type==='PROGRESSIVE' && !isConnected(listValue)) && connectedCampaigns.length===0
                                                },
                                                {
                                                    title: "Seleccionar",
                                                    action: () => { history.push("/campaign/" + listValue._id)},
                                                    visible:listValue.type==='ASSISTED'
                                                },
                                                
                                                {
                                                    title: "Desconectarse",
                                                    action: () => { executeUserAMIAction({ action: 'QUEUEREMOVE', queue: listValue.asteriskQueueInfo.name }); unassignCampaign(listValue) },
                                                    visible:isConnected(listValue)
                                                },
                                                
                                                {
                                                    title: "Agendar ejecución",
                                                    action: () => scheduleCampaign(listValue),
                                                    visible: (sessionData.profile_code === 'SUPV')
                                                },
                                                {
                                                    title: "Ejecutar ahora",
                                                    action: () => { executeNow(listValue);},
                                                    visible: (sessionData.profile_code === 'SUPV' && listValue.type ==='PROGRESSIVE')
                                                },
                                                {
                                                    title: "Cambiar ratio discado",
                                                    action: () => { changeRatioDialing(listValue);},
                                                    visible: (sessionData.profile_code === 'SUPV' && listValue.type ==='PROGRESSIVE')
                                                },
                                                {
                                                    title: "Eliminar",
                                                    action: () => { deleteCampaign(listValue)},
                                                    visible: (sessionData.profile_code === 'SUPV')
                                                },
                                                {
                                                    title: "Conectarse",
                                                    action: () => assignChatCampaign(listValue),
                                                    visible: (sessionData.profile_code === 'EXEC_CHAT' || sessionData.profile_code === 'EXEC_CHAT_REB')
                                                },
                                                {
                                                    title: "Ejecutar",
                                                    action: () => { executeVoiceRobotCampaign(listValue)},
                                                    visible: listValue.type === 'VOICEROBOT'
                                                },
                                            ]
                                        }/>
                                        ):null}    
                                    </td>
                                </tr>  
                            );      
                        })}   
                    </tbody>            
                </table>
            </div>

            {
                campaignsPagination ? (
                    <p className="pagination">
                        Mostrando [{campaigns.length} de {campaignsPagination.total} registros]
                        {(campaigns.length < campaignsPagination.total) ? (
                            <span> &nbsp; <a className={loading.campaigns ? 'link loading' : 'link'} onClick={() => getCampaigns({ page: campaignsPagination.page + 1, skip: campaigns.length, limit: 10 })}>Ver más</a></span>
                        ) : null}
                    </p>
                ) : null
            }
                
            <br/>

            {/* <button type="button" className='default' onClick={() => assignCampaign()} disabled={!campaign.campaignId}>Seleccionar campaña</button>  */}
           
            {(sessionData.profile_code === 'EXEC_CHAT' || sessionData.profile_code === 'EXEC_CHAT_REB') ?(
                connectedCampaigns.length > 0 ? (
                        <Chatroom setUserStatusFn={setUserStatus}/>
                ) : null
            ):null}


        </div>



        </div>
    );
}

export default Campaigns;